// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__hziRx","empty":"ModalGraph_empty__1UhDy"};